import { S } from "../customers/theme";

/**
 * Presentational product picker for document line items (Orders/Quotations/Invoices).
 * Receives the live product list as a prop (loaded once at app level via the products
 * data layer) — it never accesses Supabase itself. On selection it calls onSelect(product)
 * and resets, so it acts as an "insert product into this line" control; the line's fields
 * remain free-text editable afterwards.
 *
 * @param {{ products: Array, onSelect: (product:any)=>void, placeholder?: string, style?: object }} props
 */
export default function ProductPicker({ products = [], onSelect, placeholder = "Insert product…", style }) {
  return (
    <select
      aria-label="Insert product into line"
      value=""
      style={{ ...S.input, ...style }}
      onChange={(e) => {
        const p = products.find((x) => x.id === e.target.value);
        if (p) onSelect(p);
        e.target.value = "";
      }}
    >
      <option value="">{placeholder}</option>
      {products.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}{p.sku ? ` · ${p.sku}` : ""}{p.wholesale_price != null ? ` · €${Number(p.wholesale_price).toFixed(2)}` : ""}
        </option>
      ))}
    </select>
  );
}
